module.exports = __webpack_public_path__ + "img/no-image.1ef5bc21.png";